import { nodeDetail, readNodesFile, tokensList } from '@/utils/api';
import { parseData } from '@/utils/data_parse';

// eslint-disable-next-line no-unused-vars
function ready(requestList) {
  let supernodes = [];
  const others = [];

  for (let i = 0, len = requestList.length; i < len; i += 1) {
    // if (requestList[i].efficiency > 0 && requestList[i].address !== 'ARDeXgTQW1i87Gq6wGvkUP3qt3JhzDHUEtr') { // 有出块率的认为是supernode
    //   supernodes.push(requestList[i])
    // }else{
    //   others.push(requestList[i])
    // }
    if (requestList[i].isSuperNode) {
      supernodes.push(requestList[i]);
    } else {
      others.push(requestList[i]);
    }
  }
  supernodes.sort((a, b) => b.currentCapacity - a.currentCapacity);
  others.sort((a, b) => b.currentCapacity - a.currentCapacity);

  for (let i = 0, len = supernodes.length; i < len; i += 1) {
    supernodes[i].rank = i + 1;
  }
  for (let i = 0, len = others.length; i < len; i += 1) {
    others[i].rank = i + supernodes.length + 1;
  }
  let orderNodes = new Array(7);
  let disorderNodes = [];
  let vpower; let staked; let
    stakingkr;
  disorderNodes = supernodes.filter((item, i) => {
    if (item.name === 'Staking Club') {
      orderNodes[0] = item;
      return false;
    } if (item.name === 'HelloVSYS') {
      orderNodes[1] = item;
      return false;
    } if (item.name === 'OKEx Pool') {
      orderNodes[2] = item;
      return false;
    } if (item.name === 'ZB Group') {
      orderNodes[3] = item;
      return false;
    } if (item.name === 'Huobi Pool') {
      orderNodes[4] = item;
      return false;
    } if (item.name === 'Staking KOREA') {
      // orderNodes[5] = item;
      stakingkr = item;
      return false;
    } if (item.name === 'Black Diamond') {
      orderNodes[6] = item;
      return false;
    } if (item.name === 'V Power') {
      vpower = item;
      return false;
    } if (item.name === 'Staked.us') {
      staked = item;
      return false;
    }
    return true;
  });
  orderNodes = orderNodes.filter(item => item);
  supernodes = orderNodes.concat(disorderNodes);
  if (vpower) {
    supernodes.splice(-2, 0, vpower);
  }
  if (staked) {
    supernodes.splice(-2, 0, staked);
  }
  if (stakingkr) {
    supernodes.push(stakingkr);
  }
  return {
    nodes: supernodes,
    others,
  };
}

function buildNodeList(list) {
  if (!Array.isArray(list) || !list.length) {
    return [];
  }
  const { nodes, others } = ready(list);
  return [...nodes, ...others];
}

export default {
  namespaced: true,
  state: {
    allList: [], // 用于搜索
    nodeList: [], // 用于渲染
    requestList: [], // 用于请求数据
    listLoading: false,
    count: 15,
    effReady: false, // 出块率全部获取完后 true，列表排序可用
    rewards: [], // 节点奖励数据
    calculateReady: false,
    tokensList: [], // token列表
  },
  mutations: {
    save(state, payload) {
      Object.assign(state, payload);
      const { requestList } = state;
      state.nodeList = buildNodeList(requestList);
      state.allList = state.nodeList;
      state.calculateReady = true;
      state.effReady = true;
    },

    setListLoading(state, loading) {
      state.listLoading = loading;
    },

    saveTokensList(state, payload) {
      Object.assign(state, payload);
    },

    saveSearch(state, payload) {
      Object.assign(state, payload);
      const { requestList, nodeList } = state;
      state.nodeList = buildNodeList(nodeList);
      state.allList = requestList;
    },

    saveCurrentCapacity(state, payload) {
      const { requestList, count } = state;
      let allRead = true;
      for (let i = 0, len = requestList.length; i < len; i += 1) {
        const item = requestList[i];
        if (item.address === payload.address) {
          item.currentCapacity = payload.currentCapacity;
        }
        if (item.currentCapacity < 0) {
          allRead = false;
        }
      }
      if (allRead) {
        const { nodes, others } = ready(count, requestList);
        state.nodeList = [...nodes, ...others];
        state.allList = state.nodeList;
      }
    },

    saveEfficiency(state, payload) {
      const { nodeList } = state;
      let effReady = true;
      for (let i = 0, len = nodeList.length; i < len; i += 1) {
        const item = nodeList[i];
        if (item.address === payload.address) {
          item.efficiency = payload.efficiency;
        }
        if (item.efficiency < 0) {
          effReady = false;
        }
      }
      state.effReady = effReady;
      if (effReady) state.allList = nodeList;
    },

    saveMonthlyEfficiency(state, payload) {
      const { nodeList } = state;
      let calculateReady = true;
      for (let i = 0, len = nodeList.length; i < len; i += 1) {
        const item = nodeList[i];
        if (item.address === payload.address) {
          item.monthlyEfficiency = payload.monthlyEfficiency;
        }
        if (item.monthlyEfficiency < 0) {
          calculateReady = false;
        } else {
          const amount = 1;
          const amroi = (amount / item.currentCapacity)
            * 60 * 36 * 24 * 365 * item.monthlyEfficiency * (1 - item.fee);
          const percent = amroi / amount;
          item.roi = percent;
        }
      }
      state.calculateReady = calculateReady;
      if (calculateReady) state.allList = nodeList;
    },
    /**
     * 排序，超级节点和非超级节点分开排序
     * @param state
     * @param payload
     */
    sortList(state, payload) {
      const { nodeList, count } = state;
      const nodes = [];
      const others = [];
      for (let i = 0, len = nodeList.length; i < len; i += 1) {
        const item = nodeList[i];
        if (item.rank < count + 1) {
          nodes.push(item);
        } else {
          others.push(item);
        }
      }
      let prop = 'currentCapacity';
      let order = 'descending';
      if (payload.order) {
        const arr = payload.order.split('_');
        prop = arr[0];
        order = arr[1];
      }
      // console.log("debug sort", payload.order)
      nodes.sort((a, b) => {
        if (order === 'descending') return b[`${prop}`] - a[`${prop}`];
        return a[`${prop}`] - b[`${prop}`];
      });
      others.sort((a, b) => {
        if (order === 'descending') return b[`${prop}`] - a[`${prop}`];
        return a[`${prop}`] - b[`${prop}`];
      });
      state.nodeList = [...nodes, ...others];
    },


    calculateReward(state, payload) {
      const { allList } = state;
      const {
        idList, amount, priceUsd, token,
      } = payload;
      const rewards = [];
      for (let i = 0, len1 = idList.length; i < len1; i += 1) {
        for (let j = 0, len2 = allList.length; j < len2; j += 1) {
          const item = allList[j];
          if (item.id === Number(idList[i])) {
            let amroi = 0;
            let percent = 0;
            let amroiUsd = 0;
            let ipxIncome = '-'; let homeIncome = '-'; let
              bankIncome = '-';
            if (item.isSuperNode) {
              amroi = (amount / item.currentCapacity)
              * 60 * 36 * 24 * 365 * 1 /* item.monthlyEfficiency 获取太慢，按100%计算 */ * (1 - item.fee);
              percent = amroi / amount;
              amroiUsd = amroi * priceUsd;
            }

            if (item.tokenData && item.tokenData.length > 0) {
              item.tokenData.map((i) => {
                token.map((t) => {
                  if (i.name === t && i.name === 'IPX') {
                    if (item.currentCapacity === 0) {
                      ipxIncome = `${0} ${i.name}`;
                    } else {
                      ipxIncome = i.mint_amount / 15 / i.mint_day * 365 * (1 - i.return_rate) * (amount / item.currentCapacity);
                      ipxIncome = `${ipxIncome.toFixed(8)} ${i.name}`;
                    }
                  }
                  if (i.name === t && i.name === 'HOME') {
                    if (item.currentCapacity === 0) {
                      homeIncome = `${0} ${i.name}`;
                    } else {
                      homeIncome = i.mint_amount / 15 / i.mint_day * 365 * (1 - i.return_rate) * (amount / item.currentCapacity);
                      homeIncome = `${homeIncome.toFixed(8)} ${i.name}`;
                    }
                  }
                  if (i.name === t && i.name === 'BANK') {
                    if (item.currentCapacity === 0) {
                      bankIncome = `${0} ${i.name}`;
                    } else {
                      bankIncome = i.mint_amount / 15 / i.mint_day * 365 * (1 - i.return_rate) * (amount / item.currentCapacity);
                      bankIncome = `${bankIncome.toFixed(8)} ${i.name}`;
                    }
                  }
                });
              });
            }

            const reward = {
              amroi,
              amroiUsd,
              percent,
              ipxIncome,
              homeIncome,
              bankIncome,
              name: item.name,
              logo: item.logo,
              website: item.website,
            };
            rewards.push(reward);
          }
        }
      }
      state.rewards = rewards;
    },
  },
  actions: {
    /**
     * 获取节点数据
     * @param commit
     * @return {Promise<void>}
     */
    async getNodeList({ commit }) {
      commit('setListLoading', true);
      try {
        const res = await nodeDetail();
        if (res && res.data.code === 0) {
          const list = [];
          res.data.data.forEach((item, i) => {
            const result = {
              id: i,
              logo: item.logo,
              name: item.name,
              fee: Number(item.fee),
              address: item.Address,
              capacity: Number(item.capacity),
              cycle: item.cycle,
              country: item.location,
              website: item.url,
              efficiency: item.DailyEfficiency || 0,
              currentCapacity: item.LeaseInBalance || 0,
              monthlyEfficiency: item.MonthlyEfficiency || 0,
              roi: -1,
              isSuperNode: item.IsSuperNode,
              tokenData: item.TokenData,
              subNode: item.SubNode,
            };
            if (result.monthlyEfficiency > 0) {
              const amount = 1;
              const amroi = (amount / result.currentCapacity)
                * 60 * 36 * 24 * 365 * result.monthlyEfficiency * (1 - result.fee);
              const percent = amroi / amount;
              result.roi = percent;
            }
            list.push(result);
          });
          commit('save', { requestList: list });
        }
      } finally {
        commit('setListLoading', false);
      }
    },
    /**
     获取Token列表
     */
    async getTokensList({ dispatch, commit }) {
      const res = await tokensList();
      if (res && res.data.code === 0) {
        const list = [];
        res.data.data.map((item, i) => {
          const result = {
            id: i,
            logo: item.logo,
            name: item.name.toUpperCase(),
          };
          list.push(result);
        });
        commit('saveTokensList', { tokensList: list });
      }
    },
    /**
     * 通过地址获取 currentCapacity
     * @param commit
     * @param address
     * @return {Promise<void>}
     */
    async getAddressInfo({ commit }, address) {
      const res = await nodeDetail({ address });
      if (res && res.data.code === 0) {
        commit('saveCurrentCapacity', {
          address,
          currentCapacity: res.data.data.LeaseInBalance,
        });
      }
    },
    /**
     * 通过地址获取出块率
     * @param commit
     * @param address
     * @return {Promise<void>}
     */
    async getDetail({ commit }, address) {
      const res = await nodeDetail({
        address,
      });
      if (res && res.data.code === 0) {
        commit('saveEfficiency', {
          address,
          efficiency: res.data.data.MissBlockRate,
        });
      }
    },

    async getMonthlyEfficiency({ commit }, address) {
      const res = await nodeDetail({
        address,
        pastTime: 1440 * 30,
        reqName: 'info',
      });
      if (res && res.data.code === 0) {
        commit('saveMonthlyEfficiency', {
          address,
          monthlyEfficiency: res.data.data.MissBlockRate,
        });
      }
    },
  },
};
